export default __webpack_public_path__ + "static/media/usa.11a43445.png";